import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Permission, PermissionGroup, User } from '../types/user/user';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private _aptitudeUser$ = new ReplaySubject<User>(1);
  private _adminUser$ = new ReplaySubject<User>(1);

  aptitudeUser$ = this._aptitudeUser$.asObservable();
  adminUser$ = this._adminUser$.asObservable();
  adminUserPermissions$ = this.adminUser$.pipe(
    map((user) => {
      return user.userPermissions.reduce(
        this.permissionsGroupReducer.bind(this),
        new Map(),
      );
    }),
  );

  setAptitudeUser(currentUser: User) {
    this._aptitudeUser$.next(currentUser);
  }

  setAdminUser(currentUser: User) {
    this._adminUser$.next(currentUser);
  }

  private permissionsReducer(
    permissionMap: Map<string, Permission>,
    permission: Permission,
  ) {
    permissionMap.set(permission.permissionType, permission);
    return permissionMap;
  }

  private permissionsGroupReducer(
    userPermissionMap: Map<string, Map<string, Permission>>,
    permission: PermissionGroup,
  ) {
    userPermissionMap.set(
      permission.contextName,
      permission.permissions.reduce(this.permissionsReducer, new Map()),
    );
    return userPermissionMap;
  }
}
